import React, { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import '../App.css';
import Sidebar from "../layout/Sidebar";
import Header from './Header';

function Maincontainer() {
  const auth = localStorage.getItem('token');
  let navigate = useNavigate();

	useEffect(() => {
		if(!auth || auth == '' || auth == undefined){
			navigate('/login')}
	}, [auth]);
  
  return (
    <>
      {auth ?
        <div>
          <div className='main_container'>
            <div className='sidebar_wpr'>
              <Sidebar />
            </div>
            <div className='ctnt_wpr'>

              <Outlet />
            </div>
          </div>
        </div>
        : <Navigate to="/login" />}
    </>
  )
}
export default Maincontainer;
